import { string, Codec, number, GetInterface, array } from 'purify-ts/Codec';
import * as R from 'remeda';
export interface AreaMappings {
  fylkeNrTilKommuneMap: Map<number, Map<string, number>>;
  fylkeNrTilFylkeNavn: Map<number, string>;
  fylkeNavnTilFylkeNr: Map<string, number>;
  kommuneNavnTilNr: Map<string, number>;
  fylkeMedKommuner: FylkeMedKommuner[];
  kommuner: Område[];
}

export interface FylkerOgKommuner {
  fylker: Array<Område>;
  fylkerMedKommuner: Array<FylkeMedKommuner>;
  kommuner: Array<Område>;
}

export interface FylkeMedKommuner {
  navn: string;
  nummer: number;
  kommuner: Array<Område>;
}

export interface Område {
  navn: string;
  nummer: number;
}

export const Fylke = Codec.interface({
  navn: string,
  nummer: number,
});

export type Fylke = GetInterface<typeof Fylke>;

export const Kommune = Codec.interface({
  navn: string,
  nummer: number,
});

export type Kommune = GetInterface<typeof Kommune>;

export const KommuneList = array(Kommune);

export type KommuneList = GetInterface<typeof KommuneList>;

export const FylkeMedKommune = Codec.interface({
  navn: string,
  nummer: number,
  kommuner: array(Kommune),
});

export type FylkeMedKommune = GetInterface<typeof FylkeMedKommune>;

export const Omraader = Codec.interface({
  fylker: array(Fylke),
  fylkerMedKommuner: array(FylkeMedKommune),
  kommuner: array(Kommune),
});

export type Omraader = GetInterface<typeof Omraader>;

export function transformOmraader(omraader: Omraader): Omraader {
  const kommunerProperties = R.pipe(omraader, R.prop('kommuner'));
  const kommunerWithModifiedNames = R.pipe(
    kommunerProperties,
    R.map(kommune => ({
      navn: `${kommune.navn} (${kommune.nummer})`,
      nummer: kommune.nummer,
    })),
  );

  return R.pipe(
    omraader,
    R.set('kommuner', kommunerWithModifiedNames),
    R.set(
      'fylkerMedKommuner',
      R.pipe(
        omraader.fylkerMedKommuner,
        R.map(f => R.pipe(f, R.set('kommuner', transformKommuner(f.kommuner)))),
      ),
    ),
  );
}

function transformKommuner(kommuner: KommuneList): KommuneList {
  return R.pipe(
    kommuner,
    R.map(kommune => ({
      navn: `${kommune.navn} (${kommune.nummer})`,
      nummer: kommune.nummer,
    })),
  );
}
